<cdk-virtual-scroll-viewport
  [itemSize]="dayColumnWidth"
  [maxBufferPx]="baseInquiryBufferPx"
  [minBufferPx]="baseInquiryBufferPx"
  class="inquiry-scrollable-days"
  orientation="horizontal"
  baseInquiryHorizontalScroll
  [trackList]="bubbleList"
  [isCalendar]="true"
>
  <div
    *cdkVirtualFor="let bubbleListItem of bubbleList; trackBy: trackByDay"
    [ngClass]="{ 'calendar-weekend': bubbleListItem.dateItem.isWeekend, today: bubbleListItem.dateItem.isToday }"
    class="day-container"
  >
    <div class="calendar-day">
      <span
        *ngIf="bubbleListItem.dateItem.firstDayOfMonth"
        class="inquiry-month"
      >
        {{ bubbleListItem.dateItem.monthLong }} {{ bubbleListItem.dateItem.dateString | date: 'yyyy' }}
      </span>
      <span
        *ngIf="bubbleListItem.dateItem.calendarWeek"
        class="inquiry-week"
      >
        <span>{{ 'days.calendarWeek' | translate }} {{ bubbleListItem.dateItem.calendarWeek }}</span>
      </span>
      {{ bubbleListItem.dateItem.day }}
      <span class="inquiry-week-day">{{ bubbleListItem.dateItem.weekdayShort }}</span>
    </div>

    <div
      *ngFor="let bubble of bubbleListItem.bubbles; trackBy: trackByBubble"
      class="calendar-column"
    >
      <base-customer-shift-plan-bubble
        [isCalendar]="true"
        [bubble]="bubble"
        [isVisible]="bubbleListItem.currentPosition?.isVisible ?? true"
        (bubbleClick)="bubbleClick($event, bubbleListItem)"
      ></base-customer-shift-plan-bubble>
    </div>
  </div>
</cdk-virtual-scroll-viewport>

<base-inquiry-horizontal-scroll
  class="form-range-weeks"
  [itemsLength]="bubbleList.length"
></base-inquiry-horizontal-scroll>

<ng-template #shiftsUpdateModal>
  <base-customer-shift-details-modal
    [modalRef]="modalRef"
    [data]="data"
    [currentShift]="currentShift"
    [timeShifts]="timeShifts"
  ></base-customer-shift-details-modal>
</ng-template>
